import {MetricCard} from '../../../components/metric-card/metric-card.jsx'
import {AlertCard} from '../../../components/alert-card/alert-card.jsx'
import {ScenarioPill} from '../../../components/scenario-pill/scenario-pill.jsx'
import {Card} from '../../../components/card/card.jsx'
import {useDashboardData} from '../dashboard-hooks.js'
import styles from './climate-led.module.scss'

export function ClimateLedLayout() {
    const {metrics, active, notifications} = useDashboardData()
    const weather = metrics.data?.weather
    const climate = metrics.data?.climate
    const activeScenarios = active.data?.active || []
    const alerts = notifications.data?.notifications || []

    return (
        <div className={styles.layout}>
            <header className={styles.header}>
                <p className={styles.eyebrow}>Climate</p>
                <h1 className={styles.title}>Dashboard</h1>
            </header>

            <div className={styles.heroGrid}>
                <MetricCard
                    metricId="climate.temperature"
                    eyebrow="Inside"
                    label="Temperature"
                    value={climate?.temperatureInside}
                    unit="°C"
                    featured
                />
                <MetricCard
                    metricId="climate.humidity"
                    eyebrow="Inside"
                    label="Humidity"
                    value={climate?.humidityInside}
                    unit="%"
                />
                <MetricCard
                    metricId="weather.temperature"
                    eyebrow="Outside"
                    label="Air"
                    value={weather?.temperature}
                    unit="°C"
                />
                <MetricCard
                    metricId="weather.windSpeed"
                    eyebrow="Outside"
                    label="Wind"
                    value={weather?.windSpeed}
                    unit="m/s"
                />
            </div>

            <Card title="Active automations" eyebrow="Scenarios">
                {activeScenarios.length === 0 && (
                    <p className={styles.empty}>No scenarios running right now.</p>
                )}
                <ul className={styles.scenarioList}>
                    {activeScenarios.map(s => (
                        <li key={s.id} className={styles.scenarioRow}>
                            <span className={styles.scenarioName}>{s.name}</span>
                            <ScenarioPill active label="Live"/>
                        </li>
                    ))}
                </ul>
            </Card>

            {alerts.length > 0 && (
                <Card title="Alerts" eyebrow="Inbox">
                    {alerts.slice(0, 3).map(n => (
                        <AlertCard
                            key={n.id}
                            severity={n.severity}
                            title={n.title}
                            body={n.body}
                            timestamp={n.createdAt}
                            unread={!n.read}
                        />
                    ))}
                </Card>
            )}
        </div>
    )
}
